
      import "/static/app-config.js";
      import "/static/dynatrace.js";
      import "/static/grafana.js";
      globalThis.daraAppBuildNumber = "20260128.8";
    